module.exports = __webpack_public_path__ + "static/media/post1.f570f751.jpg";